<route>
{
  "meta": {
    "permission": [
      "base_config.view_level"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <dial-level v-model="dialog" :to-edit="toEdit" @done="reload = true" />
    <i-table
      :title="$tc('level', 2)"
      :headers="headers"
      app="base_config.level"
      api="customer.level"
      :reload.sync="reload"
      @click:create="open()"
      @click:edit="open($event)"
      :opt="{ company_id: this.company.pk }"
      :limit="4"
    >
      <template v-slot:item.description="{ item }">
        <span v-html="item.description"></span>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import DialLevel from '@/components/level/modal.vue'
export default {
  components: {
    DialLevel
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.$t('description'),
          value: 'description'
        },
        {
          text:
            this.levelBtn.delete || this.levelBtn.edit ? this.$t('action') : '',
          value: this.levelBtn.delete || this.levelBtn.edit ? 'actions' : '',
          align: 'center',
          width: '160px'
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      company: 'company/getCompanyData',
      isAdmin: 'session/isAdmin'
    }),
    levelBtn() {
      return {
        edit: this.getPermissions([`base_config.change_level`]),
        delete: this.getPermissions([`base_config.delete_level`])
      }
    }
  },
  data() {
    return {
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    }
  }
}
</script>
